import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { BeneficiariComponent } from './beneficiari.component';
import { InfoBeneficiarComponent } from './info-beneficiar/info-beneficiar.component';

@NgModule({
    declarations: [BeneficiariComponent, InfoBeneficiarComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
    exports: [BeneficiariComponent]
})
export class BeneficiariModule { }
